import { render } from "./DataMapperInvocationAdmin.vue?vue&type=template&id=45d8bd05&scoped=true"
import script from "./DataMapperInvocationAdmin.vue?vue&type=script&lang=js"
export * from "./DataMapperInvocationAdmin.vue?vue&type=script&lang=js"

import "./DataMapperInvocationAdmin.vue?vue&type=style&index=0&id=45d8bd05&scoped=true&lang=css"
import "./DataMapperInvocationAdmin.vue?vue&type=style&index=1&id=45d8bd05&lang=scss"
import "./DataMapperInvocationAdmin.vue?vue&type=style&index=2&id=45d8bd05&lang=scss"

import exportComponent from "/Users/sivasankarelango/Sivasankar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45d8bd05"]])

export default __exports__